<template>
  <div v-loading="loading"
       :element-loading-text="loadingText"
       class="upload-package">
    <el-form
        ref="form"
        :model="form"
        label-width="200px"
        style="padding-left: 128px;">
      <el-form-item
          label="箱数"
          prop="numberOfPackages"
          :rules="[
          { required: true, message: '请输入箱数', trigger: ['blur', 'change'] },
          $gjReRule(RE.pt, '请输入大于0的整数')
        ]">
        <gj-input
            v-model="form.numberOfPackages"
            width="88px"
        ></gj-input>
      </el-form-item>

      <el-form-item>
        <div slot="label">
          选择模板
          <gj-tooltip>
            <template #content>
              当使用“含保质期模板”时，“Box X-Exp.Date”字段一列不能为空；<br>
              如果是没有保质期的商品需要填写“Not applicable”；<br>
              如果有保质期的商品需要填写“年/月/日”；
            </template>
            <i class="iconfont iconbangzhu" style="font-size: 13px;color: #666;"></i>
          </gj-tooltip>
        </div>
        <gj-select
            v-model="templateType"
            :options="[
              {id:'not_shelf_life',text:'不含保质期模板'},
              {id:'shelf_life',text:'含保质期模板'}
            ]"
            width="130px"
            :clearable="false"
        >
        </gj-select>
        <gj-button
            type="text"
            @click="generatePackListTemplate"
            style="margin-left: 8px;"
            :disabled="!(form.numberOfPackages>0)"
            >
          下载模板
          <i v-if="templateDownloadLoading" class="el-icon-loading"></i>
        </gj-button>

      </el-form-item>

      <el-form-item
          label="上传装箱文件">
        <div @click="beforeUpload">
          <gj-upload
              style="margin-bottom: 10px;"
              container-type="PACK_LIST"
              :container-biz-id="id"
              :show-file-list="false"
              :deletable="false"
              @uploadAfter="uploadAfter"
          ></gj-upload>
        </div>
      </el-form-item>
    </el-form>
    <div style="flex: 1;">
      <gj-alert
          v-if="shipment.fbaPackage === FbaShipmentEnum.fbaPackage.UPLOAD_SUCCESS"
          show-icon
          type="success"
          :closable="false">
        上传成功，批次编号：{{feedId}}
        <gj-link
            v-if="isMeaningful(fbaPackageFileId)"
            @click="viewFbaPackage(fbaPackageFileId)">
          <span style="margin: 0 10px;">{{fbaPackageFileName}}</span>
          <i v-if="fbaPackageFileDownloadLoading" class="el-icon-loading" style="line-height: unset;"></i>
        </gj-link>
      </gj-alert>
      <gj-alert
          v-if="shipment.fbaPackage === FbaShipmentEnum.fbaPackage.UPLOAD_FAILED"
          type="error"
          :closable="false"
          show-icon>
        上传失败!
        <gj-link
            v-if="isMeaningful(fbaPackageFileId)"
            @click="viewFbaPackage(fbaPackageFileId)"
            style="width: 164px;">
          <span style="margin: 0 5px 0 10px;">{{fbaPackageFileName}}</span>
          <i v-if="fbaPackageFileDownloadLoading" class="el-icon-loading" style="line-height: unset;"></i>
        </gj-link>
        <gj-link
            v-if="isMeaningful(shipment.fbaPackageFeedMsg)"
            @click="viewErrorReport(shipment.fbaPackageFeedMsg)">
          《失败原因报告》
          <i v-if="errorReportDownloadLoading" class="el-icon-loading" style="line-height: unset;"></i>
        </gj-link>
      </gj-alert>
    </div>
    <el-row
        type="flex"
        align="middle"
        justify="center"
        style="margin-top: 10px;">
      <gj-button
          @click="cancel"
      >取消</gj-button>
      <gj-button
          @click="previousStep"
      >上一步</gj-button>
      <gj-button
          type="primary"
          :disabled="shipment.fbaPackage !== FbaShipmentEnum.fbaPackage.UPLOAD_SUCCESS"
          @click="nextStep"
      >下一步</gj-button>
    </el-row>
  </div>
</template>

<script>
  import {
    formMixin,
    formRuleMixin,
    formValidatorMixin, isMeaningfulMixin,
    responseMixin,
    stepsMixin,
    uploadMixin
  } from "@/minxins";
  import {
    generatePackListTemplate,
    getPackListFeedResult,
    uploadShipmentPackList
  } from "@/api/logistics";
  import {FbaShipmentEnum} from "@/views/modules/common/logistics/enum";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  import {downloadAttFile} from "@/api/common";

  export default {
    name: "app-step-3",
    mixins: [formMixin, formValidatorMixin, formRuleMixin, stepsMixin,
      uploadMixin, responseMixin, isMeaningfulMixin],
    props: {
      id: {
        required: true
      },
      shipment: {
        required: true
      }
    },
    data() {
      return {
        FbaShipmentEnum: FbaShipmentEnum,
        loading: false,
        loadingText: null,
        templateDownloadLoading: false,
        errorReportDownloadLoading: false,
        feedId: null,
        getPackListFeedResultInterval: null,

        fbaPackageFileDownloadLoading: false,
        fbaPackageFileId: null,
        fbaPackageFileName: null,
        templateType:this.shipment.packageTemplateType||'not_shelf_life'

      }
    },
    watch: {
      shipment: {
        handler(data) {
          if (isMeaningful(data)) {
            if (isMeaningless(this.feedId)) {
              // 初始化时feedId为空才赋值，否则说明客户又重新上传了文件，此时无需初始化，下面两个if的处理逻辑一样
              this.feedId = data.fbaPackageFeed;
            }
            if (isMeaningless(this.fbaPackageFileId)) {
              this.fbaPackageFileId = data.fbaPackageFileId;
            }
            if (isMeaningless(this.fbaPackageFileName)) {
              this.fbaPackageFileName = data.fbaPackageFileName;
            }
            // package uploading
            if (data.fbaPackage === FbaShipmentEnum.fbaPackage.UPLOADING) {
              this.intervalGetPackListFeedResult();
            }
          }
        },
        immediate: true
      }
    },
    methods: {
      viewErrorReport(feedErrorFileId) {
        this.errorReportDownloadLoading = true;
        downloadAttFile(feedErrorFileId)
          .complete(() => this.errorReportDownloadLoading = false);
      },
      viewFbaPackage(fileId) {
        this.fbaPackageFileDownloadLoading = true;
        downloadAttFile(fileId)
          .complete(() => this.fbaPackageFileDownloadLoading = false);
      },
      generatePackListTemplate() {
        if (this.formValidate()) {
          this.templateDownloadLoading = true;
          generatePackListTemplate({
            id: this.id,
            numberOfPackages: this.form.numberOfPackages,
            templateType:this.templateType
          })
            .complete(() => this.templateDownloadLoading = false);
        }
      },
      beforeUpload($event) {
        if (!this.formValidate()) {
          $event.preventDefault();
        }
      },
      uploadAfter(attId, attachment) {
        this.fbaPackageFileName = attachment.submittedFileName;
        this.fbaPackageFileId = attId;
        this.$emit('markUpdate');
        if (this.formValidate()) {
          this.loading = true;
          this.loadingText = '上传亚马逊中。。。';
          uploadShipmentPackList({
            id: this.id,
            attachmentId: attId,
            numberOfPackages: this.form.numberOfPackages,
            templateType:this.templateType
          })
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.feedId = res.data;
                this.intervalGetPackListFeedResult();
              }, () => {
                this.$gjMessage.error(res.msg || '网络错误');
                this.loading = false;
              });
            })
            .catch(() => this.loading = false);
        }
      },
      intervalGetPackListFeedResult() {
        this.loading = true;
        this.loadingText = '亚马逊处理中，大约1-3分钟...';
        this.getPackListFeedResultInterval = setInterval(() => {
          this.getPackListFeedResult();
        }, 3000);
      },
      getPackListFeedResult() {
        getPackListFeedResult(this.id)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              if (isMeaningful(res.data.feedResult)) {
                if (res.data.feedResult) {
                  this.shipment.fbaPackage = FbaShipmentEnum.fbaPackage.UPLOAD_SUCCESS;
                  this.feedId = res.data.feedId;
                } else {
                  this.shipment.fbaPackage = FbaShipmentEnum.fbaPackage.UPLOAD_FAILED;
                  this.shipment.fbaPackageFeedMsg = res.data.feedErrorFileId;
                  this.feedId = res.data.feedId;
                }
                this.clearGetPackListFeedResultInterval();
              }
            });
          })
      },
      clearGetPackListFeedResultInterval() {
        this.loading = false;
        this.loadingText = null;
        if (isMeaningful(this.getPackListFeedResultInterval)) {
          clearInterval(this.getPackListFeedResultInterval);
        }
      }
    },
    destroyed() {
      this.clearGetPackListFeedResultInterval();
    }
  }
</script>

<style lang="scss" scoped>
  .upload-package {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  /deep/ .el-alert__icon.is-big {
    font-size: 18px;
    width: 18px;
  }
  /deep/ .el-loading-spinner {
    top: 180px;
  }
  /*/deep/ .el-loading-spinner .circular {*/
  /*  display: none;*/
  /*}*/
</style>
